<template>
  <b-row>
    <b-col md="8">
      <b-card>
        <b-row>
          <b-col cols="12 mb-1">
            <b-badge variant="light-warning" v-if="form.status === 0">{{
              form.status_name
            }}</b-badge>
            <b-badge variant="light-warning" v-else-if="form.status === 1">{{
              form.status_name
            }}</b-badge>
            <b-badge variant="light-primary" v-else-if="form.status === 2">{{
              form.status_name
            }}</b-badge>
            <b-badge variant="light-danger" v-else-if="form.status === 3">{{
              form.status_name
            }}</b-badge>
            <b-badge variant="light-secondary" v-else-if="form.status === 4">{{
              form.status_name
            }}</b-badge>
            <b-badge variant="light-info" v-else-if="form.status === 5">{{
              form.status_name
            }}</b-badge>
            <b-badge variant="light-dark" v-else-if="form.status === 6">{{
              form.status_name
            }}</b-badge>
            <b-badge variant="light-primary" v-else-if="form.status === 7">{{
              form.status_name
            }}</b-badge>
            <b-badge variant="light-success" v-else-if="form.status === 8">{{
              form.status_name
            }}</b-badge>
          </b-col>
          <b-col cols="12" md="12">
            <b-row v-if="form.status === 3">
              <b-col cols="6" md="6" class="text-left"> Reject Order </b-col>
              <b-col cols="6" md="6" class="text-right font-weight-bolder">
                {{ form.reject_reason }}
              </b-col>
            </b-row>
            <hr v-if="form.status === 3" />
            <b-row>
              <b-col cols="6" md="6" class="text-left"> Order Code </b-col>
              <b-col cols="6" md="6" class="text-right font-weight-bolder">
                {{ form.code }}
              </b-col>
            </b-row>
            <hr />
            <b-row>
              <b-col cols="6" md="6" class="text-left"> Order Date </b-col>
              <b-col cols="6" md="6" class="text-right font-weight-bolder">
                {{ moment(form.created_at) }} WIB
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
      <b-card>
        <label class="font-weight-bolder text-primary mb-1" for="product"
          >Customer Informations</label
        >
        <b-row>
          <b-col md="3"> Customer <span class="float-right">:</span> </b-col>
          <b-col md="9">
            <span class="font-weight-bolder">{{ customer.name }}</span>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col md="3"> Email <span class="float-right">:</span> </b-col>
          <b-col md="9">
            <span class="font-weight-bolder">{{ customer.email }}</span>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col md="3">
            Business Phone <span class="float-right">:</span>
          </b-col>
          <b-col md="9">
            <span class="font-weight-bolder">{{
              customer.business_phone
            }}</span>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col md="3"> Fax <span class="float-right">:</span> </b-col>
          <b-col md="9">
            <span class="font-weight-bolder">{{ customer.fax }}</span>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col md="3"> Website <span class="float-right">:</span> </b-col>
          <b-col md="9">
            <span class="font-weight-bolder">{{ customer.website }}</span>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col md="3"> PIC <span class="float-right">:</span> </b-col>
          <b-col md="9">
            <span class="font-weight-bolder">{{ customer.pic }}</span>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col md="3">
            Personal Phone <span class="float-right">:</span>
          </b-col>
          <b-col md="9">
            <span class="font-weight-bolder">{{
              customer.personal_phone
            }}</span>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col md="3"> Address <span class="float-right">:</span> </b-col>
          <b-col md="9">
            <span class="font-weight-bolder"
              >{{ customer.address }}, {{ customer.city }},
              {{ customer.village }}, {{ customer.district }},
              {{ customer.province }}, {{ customer.country }},
              {{ customer.postal_code }}</span
            >
          </b-col>
        </b-row>
      </b-card>
      <b-card>
        <label class="font-weight-bolder text-primary mb-1" for="product"
          >List Product</label
        >
        <b-row class="mb-1" v-for="(product, list) in products" :key="list">
          <b-col cols="12">
            <b-row>
              <b-col cols="12" md="12">
                <b-img
                  thumbnail
                  fluid
                  :src="product.image"
                  width="150"
                  class="float-left mr-1"
                  style="height: 150px; object-fit: contain"
                />
                <b-row>
                  <b-col md="6">
                    <div class="mb-2 font-weight-bolder">
                      {{ product.code }}
                    </div>
                    <div class="text-success font-weight-bolder">
                      {{ product.name }}
                    </div>
                    <div>
                      {{ product.qty }} {{ product.unit }} X
                      {{ formatRupiah(product.price) }}
                    </div>
                  </b-col>
                  <b-col md="6" class="text-right mt-3">
                    <div>Subtotal Price</div>
                    <div class="font-weight-bolder">
                      {{ formatRupiah(product.total_price) }}
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <!-- <b-row>
                    <b-col md="6" class="font-weight-bolder text-right">Total</b-col>
                    <b-col md="6" class="font-weight-bolder text-primary text-right"><span class="mr-1">{{ formatRupiah(form.purchase_price) }}</span></b-col>
                </b-row> -->
      </b-card>
      <b-card>
        <label class="font-weight-bolder text-primary mb-1" for="product"
          >Delivery Informations</label
        >
        <b-row>
          <b-col md="3">
            Shipping Name <span class="float-right">:</span>
          </b-col>
          <b-col md="9">
            <span class="font-weight-bolder">{{ form.shipping_name }}</span>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col md="3"> Name <span class="float-right">:</span> </b-col>
          <b-col md="9">
            <span class="font-weight-bolder">{{ delivery.name }}</span>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col md="3"> Phone <span class="float-right">:</span> </b-col>
          <b-col md="9">
            <span class="font-weight-bolder">{{ delivery.phone }}</span>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col md="3"> Address <span class="float-right">:</span> </b-col>
          <b-col md="9">
            <span class="font-weight-bolder"
              >{{ customer.address }}, {{ customer.city }},
              {{ customer.village }}, {{ customer.district }},
              {{ customer.province }}, {{ customer.country }},
              {{ customer.postal_code }}</span
            >
          </b-col>
        </b-row>
      </b-card>

      <b-card>
        <label class="font-weight-bolder text-primary mb-1" for="product"
          >Payment Details</label
        >
        <b-row>
          <b-col cols="6" md="3"> Purchase Price </b-col>
          <b-col cols="6" md="9" class="text-right font-weight-bolder">
            {{ formatRupiah(form.purchase_price) }}
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col cols="6" md="3"> Shipping Cost </b-col>
          <b-col cols="6" md="9" class="text-right font-weight-bolder">
            {{ formatRupiah(form.shipping_cost) }}
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col cols="6" md="3"> Tax </b-col>
          <b-col cols="6" md="9" class="text-right font-weight-bolder">
            {{ formatRupiah(form.tax) }}
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col cols="6" md="3"> Discount </b-col>
          <b-col
            cols="6"
            md="9"
            class="text-right font-weight-bolder text-warning"
          >
            {{ "- " + formatRupiah(form.discount) }}
          </b-col>
        </b-row>
        <hr class="height-5" />
        <b-row>
          <b-col cols="6" md="3"> Total </b-col>
          <b-col
            cols="6"
            md="9"
            class="text-right font-weight-bolder text-success"
          >
            {{ formatRupiah(form.gross_price) }}
          </b-col>
        </b-row>
      </b-card>

      <b-row v-if="form.status === 0">
        <b-col>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="danger"
            class="mr-1"
            block
            @click="deleteOrder()"
            v-if="permissions.includes('sales-order-delete')"
          >
            Delete
          </b-button>
        </b-col>
        <b-col>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="success"
            class="mr-1"
            block
            @click="submit()"
            v-if="permissions.includes('sales-order-update')"
          >
            Submit
          </b-button>
        </b-col>
      </b-row>
      <b-row v-if="form.status === 1">
        <b-col>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="danger"
            class="mr-1"
            block
            v-b-modal.modal-reject
            v-if="permissions.includes('sales-order-approval')"
          >
            Reject
          </b-button>
        </b-col>
        <b-col>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="success"
            class="mr-1"
            block
            @click="approve()"
            v-if="permissions.includes('sales-order-approval')"
          >
            Approve
          </b-button>
        </b-col>
      </b-row>
      <b-row v-if="form.status === 7">
        <b-col>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="success"
            class="mr-1"
            block
            @click="finish()"
            v-if="permissions.includes('sales-order-update')"
          >
            Finish
          </b-button>
        </b-col>
      </b-row>
      <!-- modal reject -->
      <b-modal
        id="modal-reject"
        title="Reject Form"
        ok-title="Reject"
        cancel-variant="outline-secondary"
        hide-footer
      >
        <validation-observer ref="loginValidation">
          <b-form ref="form" @submit.prevent>
            <b-form-group
              :state="errors"
              label="Reject Reason"
              label-for="reject"
              invalid-feedback="Reject Reason required"
            >
              <validation-provider
                #default="{ errors }"
                name="reject"
                rules="required"
              >
                <b-form-input
                  id="reject"
                  name="reject"
                  type="text"
                  v-model="form.reject_reason"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Reject Reason"
                  required="required"
                />
                <small class="text-danger">{{ errors[0] || errMessage }}</small>
              </validation-provider>
            </b-form-group>

            <b-row>
              <b-col>
                <b-button
                  class="mt-3"
                  type="submit"
                  variant="danger"
                  block
                  @click="reject()"
                >
                  Reject
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-modal>
      <!-- end modal reject -->
    </b-col>
    <b-col md="4">
      <b-card>
        <label class="font-weight-bolder text-primary mb-2" for="product"
          >Order History</label
        >
        <app-timeline>
          <app-timeline-item
            v-for="(log, index) in logs"
            :key="index"
            :title="log.description"
            subtitle=""
            :time="moment(log.created_at)"
            :variant="log.variant"
          />
        </app-timeline>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BImg,
  BContainer,
  BBadge,
  BFormSelect,
  BListGroupItem,
  BAvatar,
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Prism from "vue-prism-component";
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment";
import { $themeConfig } from "@themeConfig";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";

export default {
  components: {
    AppTimeline,
    AppTimelineItem,
    ToastificationContent,
    BImg,
    BContainer,
    ValidationProvider,
    ValidationObserver,
    BBadge,
    BFormSelect,
    BListGroupItem,
    BAvatar,
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    Prism,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      form: {
        code: "",
        created_at: "",
        purchase_price: null,
        shipping_cost: null,
        tax: null,
        discount: null,
        gross_price: null,
        status: null,
        status_name: "",
        reject_reason: "",
        customer_name: "",
        customer_id: null,
        shipping_name: "",
      },
      customer: {
        name: "",
        email: "",
        business_phone: null,
        fax: null,
        website: "",
        pic: "",
        personal_phone: null,
        address: "",
        city: "",
        village: "",
        district: "",
        province: "",
        country: "",
        postal_code: null,
      },
      delivery: {
        name: "",
        address: "",
        city: "",
        village: "",
        district: "",
        province: "",
        country: "",
        postal_code: null,
        phone: null,
      },
      permissions: [],
      products: [],
      logs: [],
      url: "",
      errors: "",
      errMessage: "",
    };
  },
  setup() {
    // App Name
    const { baseUrl, apiUrl } = $themeConfig.app;
    return {
      baseUrl,
      apiUrl,
    };
  },
  created() {
    this.getAllPermissions();
    this.getDetails();
    this.getDetailsItem();
    this.getDeliveryInformations();
  },
  methods: {
    formatRupiah(money) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      }).format(money);
    },
    moment(date) {
      return moment(date).format("DD-MM-YYYY, hh:mm");
    },
    getAllPermissions() {
      this.permissions = sessionStorage.getItem("permissions");
    },
    getDetails() {
      const id = this.$route.params.id;
      this.$http.get("sales/order/" + id).then((response) => {
        // console.log(response.data.data)
        this.form.code = response.data.data.code;
        this.form.created_at = response.data.data.created_at;
        this.form.purchase_price = response.data.data.purchase_price;
        this.form.shipping_cost = response.data.data.shipping_cost;
        this.form.tax = response.data.data.tax;
        this.form.discount = response.data.data.discount;
        this.form.gross_price = response.data.data.gross_price;
        this.form.status = response.data.data.status;
        this.form.status_name = response.data.data.status_name;
        this.form.customer_name = response.data.data.customer_name;
        this.form.customer_id = response.data.data.customer_id;
        this.form.shipping_name = response.data.data.shipping_name;
        this.form.reject_reason = response.data.data.reject_reason;
        this.getCustomer();
        this.getLogs();
      });
    },
    getDetailsItem() {
      const id = this.$route.params.id;
      this.$http.get("sales/order/" + id + "/items").then((response) => {
        // console.log(response.data.data)
        const { baseUrl } = $themeConfig.app;
        this.url = baseUrl;
        this.url += "storage/product/";

        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          var $data = {
            category: datas[i].category,
            code: datas[i].code,
            id: datas[i].id,
            image: this.url + datas[i].image,
            name: datas[i].name,
            price: datas[i].price,
            product_id: datas[i].product_id,
            qty: datas[i].qty,
            total_price: datas[i].total_price,
            unit: datas[i].unit,
          };
          this.products.push($data);
        }
        // console.log(this.products)
      });
    },
    getCustomer() {
      this.$http
        .get("sales/customer/" + this.form.customer_id)
        .then((response) => {
          // console.log(response.data.data)
          this.customer.name = response.data.data.name;
          this.customer.email = response.data.data.email;
          this.customer.business_phone = response.data.data.business_phone;
          this.customer.fax = response.data.data.fax;
          this.customer.website = response.data.data.website;
          this.customer.pic = response.data.data.pic;
          this.customer.personal_phone = response.data.data.personal_phone;
          this.customer.address = response.data.data.address;
          this.customer.city = response.data.data.city;
          this.customer.village = response.data.data.village;
          this.customer.district = response.data.data.district;
          this.customer.province = response.data.data.province;
          this.customer.country = response.data.data.country;
          this.customer.postal_code = response.data.data.postal_code;
        });
    },
    getDeliveryInformations() {
      const id = this.$route.params.id;
      this.$http.get("sales/order/" + id + "/address").then((response) => {
        // console.log(response.data.data)
        this.delivery.name = response.data.data.name;
        this.delivery.address = response.data.data.address;
        this.delivery.city = response.data.data.city;
        this.delivery.village = response.data.data.village;
        this.delivery.district = response.data.data.district;
        this.delivery.province = response.data.data.province;
        this.delivery.country = response.data.data.country;
        this.delivery.postal_code = response.data.data.postal_code;
        this.delivery.phone = response.data.data.phone;
      });
    },
    getLogs() {
      const id = this.$route.params.id;
      this.$http.get("sales/order/" + id + "/logs").then((response) => {
        // console.log(response.data.data)
        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          if (this.form.status === 3) {
            var $data = {
              description: datas[i].description,
              created_at: datas[i].created_at,
              variant: "danger",
            };
            this.logs.push($data);
          } else if (this.form.status === 7) {
            var $data = {
              description: datas[i].description,
              created_at: datas[i].created_at,
              variant: "secondary",
            };
            this.logs.push($data);
          } else if (i === datas.length - 1) {
            var $data = {
              description: datas[i].description,
              created_at: datas[i].created_at,
              variant: "primary",
            };
            this.logs.push($data);
          } else {
            var $data = {
              description: datas[i].description,
              created_at: datas[i].created_at,
              variant: "secondary",
            };
            this.logs.push($data);
          }
        }
      });
    },
    submit() {
      const id = this.$route.params.id;
      this.$http
        .post("sales/order/" + id + "/submit")
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Order Submited",
              variant: "success",
            },
          });
          location.href = "/sales/order";
          // console.log(response.data.data)
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
    approve() {
      const id = this.$route.params.id;
      this.$http
        .post("sales/order/" + id + "/approve")
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Order Approved",
              variant: "success",
            },
          });
          location.href = "/sales/order";
          // console.log(response.data.data)
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
    reject() {
      const id = this.$route.params.id;
      this.$http
        .post("sales/order/" + id + "/reject", {
          reject_reason: this.form.reject_reason,
        })
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Order Rejected",
              variant: "danger",
            },
          });
          location.href = "/sales/order";
          // console.log(response.data.data)
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
    finish() {
      const id = this.$route.params.id;
      this.$http
        .post("sales/order/" + id + "/finish")
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Order Finished",
              variant: "success",
            },
          });
          location.href = "/sales/order";
          // console.log(response.data.data)
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
    deleteOrder() {
      const id = this.$route.params.id;
      this.$http
        .post("sales/order/" + $id + "/delete")
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Order has been deleted",
              variant: "danger",
            },
          });
          location.href = "/sales/order";
          console.log(response.data.data);
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          console.log(errors.response);
        });
    },
  },
};
</script>